import { render, staticRenderFns } from "./KYCRiskRating.vue?vue&type=template&id=c0e2787c&"
import script from "./KYCRiskRating.vue?vue&type=script&lang=js&"
export * from "./KYCRiskRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports